import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useTechnologyList = (params?: any) => {
  return useQuery({
    queryKey: ['technology-list', params],
    queryFn: async () => {
      const res = await request.get('/course-technology', { params });
      return res.data;
    }
  });
};

export const useCourseTechnologyList = useTechnologyList;
